<script>
export default {
  name: "ButtonInLineFormatter",
  functional: true,
  props: {
    icon: {
      type: String,
      default: "el-icon-edit"
    },
    buttonType: {
      type: String,
      default: "primary"
    },
    onClick: {
      type: Function
    }
  },

  render(createElement, context) {
    let selectedRow = context.data.attrs.row;
    let element;
    element = createElement("el-button", {
      props: {
        type: context.props.buttonType,
        size: "small"
      },
      domProps: {
        innerHTML: `<i class=${context.props.icon}></i>`
      },
      nativeOn: {
        // eslint-disable-next-line no-unused-vars
        click: (event) => {
          context.props.onClick(selectedRow);
        }
      }
    });
    return element;
  }
};
</script>
